
(function () {
  'use strict';

  var syncTimer;
  var syncing = false;
  var syncPromise;
  var drawerObserver;
  var dispatchLocation = '';
  var locationPromise;
  var lastRenderSignature = '';
  var productCache = {};
  var referencePrices = {};
  var cartRevision = 0;
  var mutationQueue = Promise.resolve();
  var pendingMutations = 0;
  var mutationFailure = null;

  function route(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root + path;
  }

  function knownReferencePrices(cart) {
    Object.assign(referencePrices, parseJson('VivarroVariantPrices') || {}, parseJson('VivarroCartVariantPrices') || {});
    (cart.items || []).forEach(function (item) {
      if (Object.prototype.hasOwnProperty.call(referencePrices, item.variant_id)) {
        item.vivarro_compare_at_price = referencePrices[item.variant_id];
      }
    });
    return cart;
  }

  function runCartMutation(operation) {
    pendingMutations += 1;
    mutationFailure = null;
    var job = mutationQueue.then(operation);
    mutationQueue = job.catch(function (error) { mutationFailure = error; });
    return job.finally(function () { pendingMutations = Math.max(0, pendingMutations - 1); });
  }

  function cartError(error) {
    window.alert(error.message || 'Impossibile aggiornare il carrello. Riprova.');
  }

  function cartImage(url) {
    if (!url) return '';
    try {
      var image = new URL(url, window.location.origin);
      if (image.hostname === window.location.hostname || image.hostname === 'cdn.shopify.com') {
        image.searchParams.set('width', '180');
      }
      return image.href;
    } catch (error) { return url; }
  }

  function parseJson(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function getConfig() {
    var defaults = parseJson('VivarroCartDefaults') || {};
    var template = parseJson('VivarroTemplateUpsells');
    if (template && Array.isArray(template.products)) {
      defaults.title = template.title || defaults.title;
      defaults.button = template.button || defaults.button;
      defaults.products = template.products;
    }
    return defaults;
  }

  function visibleCartItems(config, cart) {
    var protectionId = config.protection && String(config.protection.variantId || '');
    return (cart.items || []).filter(function (item) {
      return String(item.variant_id) !== protectionId;
    });
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '€' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function productData(handle) {
    if (!handle) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(productCache, handle)) return productCache[handle];

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed');
        return response.json();
      })
      .catch(function () { return null; });

    return productCache[handle];
  }

  function enrichCartItems(cart) {
    return Promise.all((cart.items || []).map(function (item) {
      if (Object.prototype.hasOwnProperty.call(referencePrices, item.variant_id)) {
        item.vivarro_compare_at_price = referencePrices[item.variant_id];
        return Promise.resolve();
      }
      return productData(item.handle).then(function (product) {
        if (!product || !Array.isArray(product.variants)) return;
        var variant = product.variants.find(function (candidate) {
          return String(candidate.id) === String(item.variant_id);
        });
        item.vivarro_compare_at_price = variant ? Number(variant.compare_at_price || 0) : 0;
        if (variant) referencePrices[item.variant_id] = item.vivarro_compare_at_price;
      });
    })).then(function () { return cart; });
  }

  function discountTitles(item) {
    var titles = [];

    (item.discounts || []).forEach(function (discount) {
      if (discount && discount.title) titles.push(String(discount.title));
    });

    (item.line_level_discount_allocations || []).forEach(function (allocation) {
      var application = allocation && allocation.discount_application;
      if (application && application.title) titles.push(String(application.title));
    });

    return titles.filter(function (title, index) {
      return titles.indexOf(title) === index;
    });
  }

  function discountBadges(item) {
    var titles = discountTitles(item);
    if (!titles.length) return '';

    return '<div class="vivarro-cart-item__offers" aria-label="Offerte applicate">' +
      titles.map(function (title) {
        return '<span class="vivarro-cart-offer">' +
          '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">' +
            '<path d="M20.6 13.8 10.2 3.4H4v6.2L14.4 20a2 2 0 0 0 2.8 0l3.4-3.4a2 2 0 0 0 0-2.8Z" fill="currentColor"/>' +
            '<circle cx="7.5" cy="7.5" r="1.35" fill="#fff"/>' +
          '</svg><span>' + escapeHtml(title) + '</span></span>';
      }).join('') +
    '</div>';
  }

  function itemReferenceTotal(item) {
    var current = Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
    var original = Number(item.original_line_price || 0);
    var compareAt = Number(item.vivarro_compare_at_price || 0) * Number(item.quantity || 0);
    return Math.max(current, original, compareAt);
  }

  function addBusinessDays(date, days) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
    }
    return result;
  }

  function dispatchRange() {
    var start = addBusinessDays(new Date(), 1);
    var end = addBusinessDays(new Date(), 3);
    var startText = start.toLocaleDateString('it-IT', { day: 'numeric', month: 'long' });
    var endText = end.toLocaleDateString('it-IT', { day: 'numeric', month: 'long' });
    return startText + ' y el ' + endText;
  }

  function paintDispatch() {
    var node = document.getElementById('VivarroDispatch');
    if (!node) return;
    node.innerHTML = '<span aria-hidden="true">🚚</span> <strong>Spedizione tracciata in tutta Italia</strong>';
  }

  function loadLocation(config) {
    if (locationPromise) return locationPromise;
    paintDispatch();
    locationPromise = Promise.resolve(config.country || 'Italia');
    return locationPromise;
  }

  function renderUpsells(config, cart) {
    var wrapper = document.getElementById('VivarroProductUpsells');
    if (!wrapper) return;
    var form = wrapper.closest('form.vivarro-cart');

    var inCart = {};
    (cart.items || []).forEach(function (item) {
      inCart[String(item.variant_id)] = true;
    });

    var cartHandles = {};
    visibleCartItems(config, cart).forEach(function (item) {
      cartHandles[String(item.handle || '')] = true;
    });

    var products = (config.products || []).filter(function (product) {
      if (!product || !product.available || inCart[String(product.variantId)]) return false;
      var triggers = Array.isArray(product.triggerHandles) ? product.triggerHandles : [];
      return triggers.some(function (handle) {
        return cartHandles[String(handle)];
      });
    }).slice(0, 2);

    var signature = products.map(function (product) {
      return product.variantId;
    }).join('|');

    if (!products.length) {
      if (form) form.classList.add('vivarro-cart--no-upsells');
      wrapper.hidden = true;
      wrapper.innerHTML = '';
      wrapper.dataset.signature = '';
      return;
    }

    if (form) form.classList.remove('vivarro-cart--no-upsells');
    if (wrapper.dataset.signature === signature) return;

    var html = '<h3 class="vivarro-upsells__title">' +
      escapeHtml(config.title || 'I nostri clienti acquistano anche') +
      '</h3><div class="vivarro-upsells__list">';
    var addLabel = String(config.button || 'Aggiungi').replace(/\s*\+\s*$/, '') + ' +';

    products.forEach(function (product) {
      var compare = Number(product.compareAtPrice) > Number(product.price)
        ? '<span class="vivarro-upsell__compare">' + currencyMoney(product.compareAtPrice, config.currency) + '</span>'
        : '';

      html += '<article class="vivarro-upsell">' +
        '<a class="vivarro-upsell__image" href="' + escapeHtml(product.url) + '">' +
          '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' +
        '</a>' +
        '<div class="vivarro-upsell__info">' +
          '<a class="vivarro-upsell__name" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
          '<div class="vivarro-upsell__prices">' + compare +
            '<span class="vivarro-upsell__price">' + currencyMoney(product.price, config.currency) + '</span>' +
          '</div>' +
          '<a class="vivarro-upsell__details" href="' + escapeHtml(product.url) + '">Mostra più dettagli</a>' +
        '</div>' +
        '<button type="button" class="vivarro-upsell__add" data-vivarro-upsell="' +
          escapeHtml(product.variantId) + '">' + escapeHtml(addLabel) + '</button>' +
      '</article>';
    });

    html += '</div>';
    wrapper.dataset.signature = signature;
    wrapper.innerHTML = html;
    wrapper.hidden = false;
  }


  function itemProperties(item) {
    var properties = item.properties || {};
    return Object.keys(properties).filter(function (key) {
      return key.charAt(0) !== '_' && properties[key];
    }).map(function (key) {
      return '<span class="ajaxcart__product-meta">' + escapeHtml(key) + ': ' +
        escapeHtml(properties[key]) + '</span>';
    }).join('');
  }

  function cartItemMarkup(item, currency) {
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<span class="ajaxcart__product-meta">' + escapeHtml(item.variant_title) + '</span>'
      : '';
    var currentPrice = Number(item.final_line_price != null ? item.final_line_price : item.line_price);
    var originalPrice = itemReferenceTotal(item);
    var price = originalPrice > currentPrice
      ? '<del class="ajaxcart__price">' + currencyMoney(originalPrice, currency) + '</del>' +
        '<span class="ajaxcart__price">' + currencyMoney(currentPrice, currency) + '</span>'
      : '<span class="ajaxcart__price">' + currencyMoney(currentPrice, currency) + '</span>';

    return '<div class="ajaxcart__product fadeCartProducts vivarro-cart-item" data-variant-id="' +
      escapeHtml(item.variant_id) + '">' +
      '<div class="ajaxcart__row" data-line="' + escapeHtml(item.key) + '">' +
        '<div class="vivarro-cart-item__layout">' +
          '<a href="' + escapeHtml(item.url) + '" class="ajaxcart__product-image">' +
            '<img src="' + escapeHtml(cartImage(item.image)) + '" alt="' + escapeHtml(item.product_title || item.title) + '">' +
          '</a>' +
          '<div class="vivarro-cart-item__info">' +
            '<div class="vivarro-cart-item__top">' +
              '<div class="ajaxcart__product-name--wrapper">' +
                '<a href="' + escapeHtml(item.url) + '" class="ajaxcart__product-name">' +
                  escapeHtml(item.product_title || item.title) + '</a>' + variant + itemProperties(item) +
              '</div>' +
              '<button type="button" class="vivarro-cart-remove" data-vivarro-remove="' +
                escapeHtml(item.key) + '" aria-label="Rimuovi prodotto">' +
                '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">' +
                  '<path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
              '</button>' +
            '</div>' +
            discountBadges(item) +
            '<div class="vivarro-cart-item__bottom">' +
              '<div class="vivarro-cart-item__price">' + price + '</div>' +
              '<div class="qtybox ajaxcart__qty">' +
                '<button type="button" class="ajaxcart__qty-adjust" data-vivarro-quantity="' +
                  escapeHtml(item.key) + '" data-qty="' + Math.max(0, Number(item.quantity) - 1) +
                  '" aria-label="Riduci quantità">−</button>' +
                '<input type="text" class="quantity-selector quantity-input ajaxcart__qty-num" value="' +
                  Number(item.quantity) + '" readonly aria-label="Quantità">' +
                '<button type="button" class="ajaxcart__qty-adjust" data-vivarro-quantity="' +
                  escapeHtml(item.key) + '" data-qty="' + (Number(item.quantity) + 1) +
                  '" aria-label="Aumenta quantità">+</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function protectionMarkup(config) {
    if (!config.protection || !config.protection.variantId || config.protection.available === false) return '';
    return '<section class="vivarro-protection" aria-label="Protezione spedizione">' +
      '<button type="button" class="vivarro-protection__toggle" role="switch" aria-checked="false" ' +
        'aria-label="Aggiungi protezione spedizione" data-vivarro-protection-toggle data-variant-id="' +
        escapeHtml(config.protection.variantId) + '"></button>' +
      '<div class="vivarro-protection__copy">' +
        '<strong class="vivarro-protection__title">Protezione spedizione</strong>' +
      '</div>' +
      '<strong class="vivarro-protection__price">' +
        currencyMoney(config.protection.price, config.currency) + '</strong>' +
    '</section>';
  }

  // Afila PRO drawer: all amounts come from Shopify's confirmed cart.
  var reserveUntil = 0, reserveTicker, reservePaint;
  function afilaItems(config, cart) {
    return (cart.items || []).filter(function (item) { return config.afila && String(item.product_id) === String(config.afila.productId); });
  }
  function currencyMoney(cents, currency) { return formatMoney(cents, currency); }
  function afilaQuantity(config, cart) { return afilaItems(config, cart).reduce(function (n, i) { return n + Number(i.quantity || 0); }, 0); }
  var afilaStylesReady = false, afilaStylePromise;
  function isAfilaOnlyCart(config, cart) {
    var items = visibleCartItems(config, cart);
    return Boolean(config.afila && Number(config.afila.productId) && items.length && items.every(function(item) {
      return String(item.product_id) === String(config.afila.productId) || Boolean(config.bundleGift && String(item.variant_id)===String(config.bundleGift.variantId));
    }));
  }
  function ensureAfilaCartStyles() {
    var link = document.getElementById('VivarroAfilaCartStyles');
    if (link && link.sheet && link.media === 'all') { afilaStylesReady = true; return Promise.resolve(true); }
    if (afilaStylePromise) return afilaStylePromise;
    var url = window.VivarroCartAssets && window.VivarroCartAssets.afilaStyles;
    if (!link && !url) return Promise.resolve(false);
    afilaStylePromise = new Promise(function(resolve) {
      var timer, settled = false;
      function finish(ready) { if(settled)return; settled=true; window.clearTimeout(timer); afilaStylesReady=ready; resolve(ready); }
      if (!link) {
        link = document.createElement('link'); link.id='VivarroAfilaCartStyles'; link.rel='stylesheet'; link.media='print'; link.href=url;
        link.addEventListener('load', function(){link.media='all';finish(true);},{once:true});
        link.addEventListener('error', function(){finish(false);},{once:true});
        document.head.appendChild(link);
      } else {
        link.addEventListener('load', function(){link.media='all';finish(true);},{once:true});
        link.addEventListener('error', function(){finish(false);},{once:true});
      }
      // A missing optional stylesheet must not prevent adding items or checkout.
      timer=window.setTimeout(function(){finish(false);},3000);
    });
    return afilaStylePromise;
  }
  // Shopify's automatic Buy X Get Y rule applies the real discount to every HandGrip variant.
  function syncAfilaDiscount(config, cart) {
    return Promise.resolve(cart);
  }
  function updateReservation(cart) {
    var config=getConfig();
    if (!afilaQuantity(config, cart)) {
      reserveUntil = 0;
      try { sessionStorage.removeItem('vivarro_cart_reserve_until'); } catch (e) {}
      return;
    }
    if (!isAfilaOnlyCart(config,cart) && !reserveUntil) return;
    if (!reserveUntil) {
      try { reserveUntil = Number(sessionStorage.getItem('vivarro_cart_reserve_until')); } catch (e) {}
      if (!reserveUntil) {
        reserveUntil = Date.now() + 300000;
        try { sessionStorage.setItem('vivarro_cart_reserve_until', String(reserveUntil)); } catch (e) {}
      }
    }
    function tick() {
      var node = document.getElementById('VivarroReservationTime');
      var drawer=document.getElementById('CartDrawer');
      if (!node || document.hidden || !drawer || !drawer.classList.contains('vivarro-cart--afila') || !document.documentElement.classList.contains('js-drawer-open-right')) return;
      var seconds = Math.max(0, Math.ceil((reserveUntil - Date.now()) / 1000));
      var label = String(Math.floor(seconds / 60)).padStart(2,'0') + ':' + String(seconds % 60).padStart(2,'0');
      // Character data avoids triggering the cart's child-list observer every second.
      if (node.firstChild) node.firstChild.nodeValue = label;
      var copy = document.getElementById('VivarroReservationCopy');
      if (copy && copy.firstChild) copy.firstChild.nodeValue = seconds ? 'Il tuo carrello è riservato per' : 'Il tempo di prenotazione è terminato';
      node.setAttribute('aria-label', seconds ? 'Tempo di prenotazione rimanente: ' + label : 'Tempo di prenotazione terminato');
    }
    reservePaint=tick;
    tick();
    if (!reserveTicker) reserveTicker = window.setInterval(function(){if(reservePaint)reservePaint();}, 1000);
  }
  function afilaItemMarkup(item, currency, config) {
    var isGift=config.bundleGift && String(item.variant_id)===String(config.bundleGift.variantId);
    var afila = config.afila && String(item.product_id) === String(config.afila.productId);
    var price = Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
    var reference = itemReferenceTotal(item), saving = Math.max(0, reference - price);
    var title = afila ? 'GapBlock PRO' : item.product_title || item.title;
    var subtitle = afila ? '<span class="vv-item-subtitle">Inserti per lo spazio tra sedili e console</span>' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="ajaxcart__product-meta">' + escapeHtml(item.variant_title) + '</span>' : '';
    return '<article class="ajaxcart__product vivarro-cart-item vv-item" data-variant-id="' + escapeHtml(item.variant_id) + '"><div class="ajaxcart__row" data-line="' + escapeHtml(item.key) + '"><div class="vivarro-cart-item__layout">' +
      '<a class="ajaxcart__product-image" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(cartImage(item.image || (afila ? config.afila.image : null))) + '" width="100" height="100" alt="' + escapeHtml(item.product_title || item.title) + '"></a>' +
      '<div class="vivarro-cart-item__info"><a class="ajaxcart__product-name" href="' + escapeHtml(item.url) + '">' + escapeHtml(title) + '</a>' + subtitle + variant + itemProperties(item) +
      '<div class="vivarro-cart-item__price">' + (reference > price ? '<del class="ajaxcart__price">' + formatMoney(reference,currency) + '</del>' : '') + '<strong class="ajaxcart__price">' + currencyMoney(price,currency) + '</strong></div>' +
      (saving ? '<span class="vv-savings">Risparmi ' + formatMoney(saving,currency) + '</span>' : '') +
      '<div class="vv-item-controls"><div class="qtybox ajaxcart__qty"' + (isGift ? ' hidden' : '') + '><button type="button" class="ajaxcart__qty-adjust" data-vivarro-quantity="' + escapeHtml(item.key) + '" data-qty="' + Math.max(0,item.quantity-1) + '" aria-label="Riduci quantità">−</button>' +
      '<input class="quantity-input ajaxcart__qty-num" type="text" value="' + Number(item.quantity) + '" readonly aria-label="Quantità"><button type="button" class="ajaxcart__qty-adjust" data-vivarro-quantity="' + escapeHtml(item.key) + '" data-qty="' + (Number(item.quantity)+1) + '" aria-label="Aumenta quantità">+</button></div>' +
      '<button type="button" class="vivarro-cart-remove" data-vivarro-remove="' + escapeHtml(item.key) + '" aria-label="Rimuovi ' + escapeHtml(title) + '"><svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>' +
      discountBadges(item) + '</div></div></div></article>';
  }
  function afilaOfferMarkup(config,cart) {
    var product = config.afila, items = afilaItems(config,cart), quantity = afilaQuantity(config,cart);
    if (!product || !product.offerEnabled || config.currency !== 'EUR' || quantity !== 1 || !items.length) return '';
    var item = items[0];
    var discounted = items.some(function(i){return Number(i.final_line_price)<Number(i.original_line_price);});
    var otherCodes = (cart.discount_codes || []).some(function(d){return d.applicable;});
    var price = Number(item.original_price || item.price) || 0;
    var percent = Number(product.discountPercent) || 30;
    if (discounted || otherCodes || price <= 0) return '';
    var discount = Number(product.discountAmount) || Math.round(price * percent / 100);
    var second = Math.max(0,price - discount);
    return '<section class="vv-offer" aria-label="Offerta per il tuo ordine"><h3>OFFERTA PER IL TUO ORDINE</h3><div class="vv-offer-product"><img src="' + escapeHtml(cartImage(item.image || product.image)) + '" width="86" height="86" alt="GapBlock PRO"><div><strong class="vv-offer-title">Aggiungi il secondo kit a ' + formatMoney(second,config.currency) + '</strong><p>Stessa marca e colore del kit selezionato.</p><div class="vv-offer-prices"><del>' + formatMoney(price,config.currency) + '</del><strong>' + currencyMoney(second,config.currency) + '</strong></div><span>Risparmi ' + formatMoney(discount,config.currency) + ' sul secondo kit</span></div></div><button type="button" class="vivarro-upsell__add vv-offer-add" data-vivarro-upsell="' + escapeHtml(item.variant_id) + '"><span aria-hidden="true">＋</span> Aggiungi il secondo kit</button></section>';
  }
  function afilaProtectionMarkup(config) {
    if (!config.protection || !config.protection.variantId || config.protection.available === false) return '';
    var logo = window.VivarroCartAssets && window.VivarroCartAssets.protection;
    return '<section class="vivarro-protection" aria-label="Assicurazione spedizione facoltativa"><button type="button" class="vivarro-protection__toggle" role="switch" aria-checked="false" aria-label="Aggiungi assicurazione spedizione" data-vivarro-protection-toggle data-variant-id="' + escapeHtml(config.protection.variantId) + '"></button>' +
      (logo ? '<img class="vivarro-protection__icon" src="' + escapeHtml(logo) + '" width="36" height="36" alt="">' : '') + '<span class="vivarro-protection__title">Assicurazione spedizione</span><strong class="vivarro-protection__price">+' + currencyMoney(config.protection.price,config.currency) + '</strong></section>';
  }
  function updateShippingHeader(config,cart) {
    var title=document.getElementById('AutrixShippingTitle');
    var text=document.getElementById('AutrixShippingCopy');
    if(title)title.textContent='Spedizione tracciata';
    if(text)text.textContent='In tutta Italia · 5–7 giorni lavorativi';
  }
  function renderAfilaDrawer(config,cart,container,signature) {
    var items=visibleCartItems(config,cart), currency=config.currency;
    var saving=items.reduce(function(n,i){return n+Math.max(0,itemReferenceTotal(i)-Number(i.final_line_price != null ? i.final_line_price : i.line_price));},0);
    var subtotal=items.reduce(function(n,i){return n+Number(i.final_line_price != null ? i.final_line_price : i.line_price);},0);
    var orderDiscount=(cart.cart_level_discount_applications || []).reduce(function(n,d){return n+Number(d.total_allocated_amount || 0);},0);
    saving += orderDiscount;
    var assets=window.VivarroCartAssets||{};
    var checkoutCodes=(cart.discount_codes || []).filter(function(d){return d.applicable;}).map(function(d){return d.code;}).join(',');
    var cartAction=route('cart')+(checkoutCodes ? '?discount='+encodeURIComponent(checkoutCodes) : '');
    container.innerHTML='<form action="'+escapeHtml(cartAction)+'" method="post" novalidate class="cart ajaxcart vivarro-cart vv-afila-cart">' + (checkoutCodes ? '<input type="hidden" name="discount" value="'+escapeHtml(checkoutCodes)+'">' : '') + '<div class="ajaxcart__inner">' +
      items.map(function(i){return afilaItemMarkup(i,currency,config);}).join('') + '<span class="vivarro-cart-loader" role="status" aria-label="Aggiornamento del carrello"></span>' + afilaOfferMarkup(config,cart) +
      '</div><div class="ajaxcart__footer ajaxcart__footer--fixed"><div class="vivarro-cart-summary"><div class="vivarro-cart-summary__row"><span>Subtotale</span><strong>'+currencyMoney(subtotal,currency)+'</strong></div>' +
      (orderDiscount ? '<div class="vivarro-cart-summary__row"><span>Sconto aggiuntivo</span><strong>−'+currencyMoney(orderDiscount,currency)+'</strong></div>' : '') + (saving ? '<div class="vivarro-cart-summary__row vivarro-cart-summary__row--saving"><span>Risparmi</span><strong>'+currencyMoney(saving,currency)+'</strong></div>' : '') +
      '</div>'+afilaProtectionMarkup(config)+'<div class="vivarro-cart-summary__row vivarro-cart-summary__row--total"><span>Totale</span><strong>'+currencyMoney(cart.total_price,currency)+'</strong></div>' +
      '<button type="submit" id="cart_checkout" class="cart__checkout vivarro-checkout" name="checkout"><span class="vivarro-checkout__main"><svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M7.5 10V7a4.5 4.5 0 0 1 9 0v3M6 10h12v10H6V10Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>COMPLETA L’ACQUISTO</span></span></button>' +
      '<div class="vv-trust"><svg width="32" height="36" viewBox="0 0 24 26" aria-hidden="true"><path d="M12 1 22 5v7c0 6-4 10-10 13C6 22 2 18 2 12V5Z" fill="#4ba735"/><path d="m7 13 3 3 7-8" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Garanzia soddisfatti o rimborsati di 30 giorni</strong><span>Pagamento sicuro e dati protetti</span></div><div class="vv-payments" aria-label="Metodi di pagamento">'+(assets.payments || '')+'</div></div></div></form>';
    container.dataset.vivarroSignature=signature;
  }

  function renderDrawer(config, cart) {
    var container = document.getElementById('CartContainer');
    if (!container) return;

    var visibleItems = visibleCartItems(config, cart);
    var drawer = document.getElementById("CartDrawer");
    var afilaCart = isAfilaOnlyCart(config, cart) && afilaStylesReady;
    if (drawer) {
      drawer.classList.toggle("vivarro-cart--afila", afilaCart);
      var afilaHeader=drawer.querySelector(".vv-afila-header");
      if(afilaHeader) afilaHeader.hidden=!afilaCart;
    }
    updateReservation(cart);
    var signature = (afilaCart ? 'afila' : 'standard') + '|' + (cart.token || '') + '|' + (cart.total_price || 0) + '|' +
      (cart.items || []).map(function (item) {
        return item.key + ':' + item.quantity + ':' + (item.final_line_price || item.line_price) + ':' +
          (item.vivarro_compare_at_price || 0) + ':' + discountTitles(item).join(',');
      }).join('|');

    if (container.dataset.vivarroSignature === signature &&
        (container.querySelector('form.vivarro-cart') || container.querySelector('.vivarro-cart-empty-state'))) return;

    if (!visibleItems.length) {
      container.innerHTML =
        '<div class="vivarro-cart-empty-state" role="status">' +
          '<span class="vivarro-cart-empty-state__icon" aria-hidden="true">🛒</span>' +
          '<strong>Il tuo carrello è vuoto</strong>' +
        '</div>';
      container.dataset.vivarroSignature = signature;
      return;
    }

    if (afilaCart) { renderAfilaDrawer(config, cart, container, signature); return; }

    var itemsHtml = visibleItems.map(function (item) {
      return cartItemMarkup(item, config.currency);
    }).join('');

    var saving = visibleItems.reduce(function (total, item) {
      var current = Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
      return total + Math.max(0, itemReferenceTotal(item) - current);
    }, 0);
    var savingHtml = saving > 0
      ? '<div class="vivarro-cart-summary__row vivarro-cart-summary__row--saving fadeCartTotal">' +
          '<span>Risparmia</span><strong>-' + currencyMoney(saving, config.currency) + '</strong></div>'
      : '';

    container.innerHTML =
      '<form action="' + escapeHtml(route('cart')) + '" method="post" novalidate class="cart ajaxcart vivarro-cart">' +
        '<div class="ajaxcart__inner ajaxcart__inner--has-fixed-footer">' +
          itemsHtml +
          '<span class="vivarro-cart-loader" role="status" aria-label="Aggiornamento del carrello"></span>' +
          '<section id="VivarroProductUpsells" class="vivarro-upsells" hidden aria-label="Prodotti consigliati"></section>' +
        '</div>' +
        '<div class="ajaxcart__footer ajaxcart__footer--fixed">' +
          '<div class="vivarro-cart-summary">' +
            savingHtml +
            '<div class="vivarro-cart-summary__row vivarro-cart-summary__row--total fadeCartTotal">' +
              '<span>Totale</span><strong>' + currencyMoney(cart.total_price, config.currency) + '</strong>' +
            '</div>' +
          '</div>' +
          protectionMarkup(config) +
          '<button type="submit" id="cart_checkout" class="cart__checkout fadeCartFooter vivarro-checkout" name="checkout">' +
            '<span class="vivarro-checkout__main">' +
              '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
                '<path d="M7.5 10V7a4.5 4.5 0 0 1 9 0v3M6 10h12v10H6V10Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg><span>Completa l’acquisto</span>' +
            '</span>' +
            '<span class="vivarro-checkout__guarantee">' +
              '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">' +
                '<path d="M12 2.5 20 6v5.2c0 5.1-3.5 8.7-8 10.3-4.5-1.6-8-5.2-8-10.3V6l8-3.5Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>' +
                '<path d="m8.5 12 2.2 2.2 4.8-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg><span>Garanzia soddisfatti o rimborsati di 30 giorni</span>' +
            '</span>' +
          '</button>' +
          '<p id="VivarroDispatch" class="vivarro-dispatch fadeCartFooter">🚚 Spedizione tracciata in tutta Italia</p>' +
        '</div>' +
      '</form>';

    container.dataset.vivarroSignature = signature;
  }

  function syncProtection(config, cart) {
    var toggle = document.querySelector('[data-vivarro-protection-toggle]');
    if (!toggle || !config.protection || !config.protection.variantId) return;

    var selected = (cart.items || []).some(function (item) {
      return String(item.variant_id) === String(config.protection.variantId);
    });

    toggle.setAttribute('aria-checked', selected ? 'true' : 'false');
    toggle.setAttribute('aria-label', selected ? 'Rimuovi assicurazione spedizione' : 'Aggiungi assicurazione spedizione');

    document.querySelectorAll('.vivarro-cart-item[data-variant-id]').forEach(function (row) {
      row.classList.toggle(
        'vivarro-cart-item--protection',
        String(row.dataset.variantId) === String(config.protection.variantId)
      );
    });
  }

  function updateCount(config, cart) {
    var count = document.getElementById('VivarroCartCount');
    var quantity = visibleCartItems(config, cart).reduce(function (total, item) {
      return total + Number(item.quantity || 0);
    }, 0);
    if (count) count.textContent = '(' + quantity + ')';
  }

  function removeOrphanProtection(config, cart) {
    var protectionId = config.protection && String(config.protection.variantId || '');
    if (!protectionId || visibleCartItems(config, cart).length) return Promise.resolve(cart);

    var protectionLine = (cart.items || []).find(function (item) {
      return String(item.variant_id) === protectionId;
    });
    if (!protectionLine) return Promise.resolve(cart);

    return changeLine(protectionLine.key, 0);
  }

  function bundleProperties(item) {
    var raw = item.properties && item.properties.__kaching_bundles;
    if (typeof raw !== 'string') return null;
    try { return JSON.parse(raw); } catch (error) { return null; }
  }

  function removeInvalidBundleGifts(cart) {
    var items = cart.items || [];
    var invalid = items.find(function (item) {
      var bundle = bundleProperties(item);
      if (!bundle || !bundle.gift || !bundle.id || bundle.main) return false;
      var hasMain = items.some(function (candidate) {
        var main = bundleProperties(candidate);
        return main && main.main && main.id === bundle.id && main.deal === bundle.deal;
      });
      // Shopify's confirmed discount determines eligibility. A tagged free gift
      // must never silently become a paid item when its bundle stops qualifying.
      var finalPrice = item.final_line_price != null ? item.final_line_price : item.line_price;
      return !hasMain || Number(finalPrice) > 0;
    });
    if (!invalid) return Promise.resolve(cart);
    return changeLine(invalid.key, 0).then(removeInvalidBundleGifts);
  }

  function removeInvalidAutrixGifts(config,cart) {
    if(!config.bundleGift)return Promise.resolve(cart);
    var invalid=(cart.items||[]).find(function(item){
      if(String(item.variant_id)!==String(config.bundleGift.variantId))return false;
      var group=item.properties && item.properties._autrix_bundle;
      var quantity=(cart.items||[]).reduce(function(n,candidate){
        return n+(group && candidate.properties && candidate.properties._autrix_bundle===group && String(candidate.product_id)===String(config.afila.productId) ? Number(candidate.quantity)||0 : 0);
      },0);
      return quantity<2;
    });
    return invalid ? changeLine(invalid.key,0).then(function(next){return removeInvalidAutrixGifts(config,next);}) : Promise.resolve(cart);
  }

  function fetchCart() {
    return fetch(route('cart.js'), {
      headers: { Accept: 'application/json' }, cache: 'no-store',
      signal: AbortSignal.timeout(12000)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function paintCart(config, cart) {
    if (drawerObserver) drawerObserver.disconnect();
    var focused = document.activeElement;
    var focusLabel = focused && focused.closest('#CartDrawer') && focused.getAttribute('aria-label');
    var focusRow = focused && focused.closest('.vivarro-cart-item');
    var focusVariant = focusRow && focusRow.dataset.variantId;
    try {
      renderDrawer(config, cart);
      updateCount(config, cart);
      updateShippingHeader(config,cart);
      renderUpsells(config, cart);
      syncProtection(config, cart);
      paintDispatch(config);
      loadLocation(config);
      if (focusLabel && !document.contains(focused)) {
        var scope = focusVariant ? document.querySelector('#CartDrawer .vivarro-cart-item[data-variant-id="' + focusVariant + '"]') : document.getElementById('CartDrawer');
        var controls = scope && scope.querySelectorAll('button[aria-label]');
        if (controls) Array.from(controls).some(function (control) { if (control.getAttribute('aria-label') === focusLabel) { control.focus({preventScroll:true}); return true; } return false; });
      }
    } finally {
      if (drawerObserver) drawerObserver.observe(document.getElementById('CartDrawer'), { childList: true, subtree: true });
    }
  }

  function syncDrawer(confirmedCart) {
    if (!document.getElementById('CartDrawer')) return Promise.resolve();
    if (syncing) {
      // A response from a newer mutation must not be swallowed by an older read.
      if (confirmedCart) return syncPromise.then(function () { return syncDrawer(confirmedCart); });
      return syncPromise;
    }
    syncing = true;
    var config = getConfig();
    var revision = ++cartRevision;

    syncPromise = (confirmedCart ? Promise.resolve(confirmedCart) : fetchCart())
      .then(function(cart){return revision === cartRevision ? removeInvalidBundleGifts(cart) : cart;})
      .then(function (cart) { return revision === cartRevision ? removeInvalidAutrixGifts(config,cart) : cart; })
      .then(function (cart) { return revision === cartRevision ? removeOrphanProtection(config, cart) : cart; })
      .then(function (cart) { return syncAfilaDiscount(config, cart); })
      .then(function(cart) { return isAfilaOnlyCart(config,cart) ? ensureAfilaCartStyles().then(function(){return cart;}) : cart; })
      .then(function (cart) {
        if(revision !== cartRevision) return cart;
        // Checkout can change the presentment currency. Never label its amounts as EUR.
        if(cart.currency && cart.currency !== config.currency) {
          config.currency=cart.currency;
          if(config.afila)config.afila.offerEnabled=false;
          if(config.protection) {
            var insurance=(cart.items||[]).find(function(i){return String(i.variant_id)===String(config.protection.variantId)});
            config.protection.available=Boolean(insurance);
            if(insurance)config.protection.price=Number(insurance.final_price || insurance.price);
          }
        }
        knownReferencePrices(cart);
        paintCart(config, cart);
        // Reference prices enrich presentation only; they must not delay drawer opening.
        enrichCartItems(cart).then(function () {
          if (revision === cartRevision && pendingMutations === 0) paintCart(config, cart);
        }).catch(function () {});
        return cart;
      })
      .catch(function(error) {
        if(revision !== cartRevision) return;
        var initial=document.querySelector('#CartContainer .vv-cart-initial');
        if(initial) initial.innerHTML='<span>Impossibile caricare il carrello. Chiudilo e riaprilo per riprovare.</span>';
        throw error;
      })
      .finally(function () { if(revision === cartRevision) syncing = false; });
    return syncPromise;
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () { syncDrawer().catch(function () {}); }, 0);
  }

  function reloadNativeCart() {
    return syncing ? syncPromise.then(function () { return syncDrawer(); }) : syncDrawer();
  }

  function setCartMutationLoading(control, loading) {
    var form = control && control.closest ? control.closest('form.vivarro-cart') : null;
    if (form) { form.classList.toggle('vivarro-cart--updating', Boolean(loading)); form.setAttribute('aria-busy', String(Boolean(loading))); }
    if (!control) return;
    if (loading) control.setAttribute('aria-busy', 'true');
    else control.removeAttribute('aria-busy');
  }

  function openVivarroDrawer() {
    [document.documentElement, document.body].forEach(function (node) {
      if (!node) return;
      node.classList.remove('js-drawer-open-left');
      node.classList.add('js-drawer-open', 'js-drawer-open-right');
    });

    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.setAttribute('tabindex', '-1');
  }

  function addVariant(variantId, properties) {
    return fetch(route('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: properties || {}
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add item');
      return response.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch(route('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to change item');
      return response.json();
    });
  }

  // Legacy custom HTML can close the product form before its controls. Keep
  // those controls associated with their own form without moving visible nodes.
  function associateProductControls(button) {
    if (!button || button.form || !button.id || button.id.indexOf('AddToCart--') !== 0) return;
    var suffix = button.id.slice('AddToCart--'.length);
    var form = document.getElementById('AddToCartForm--' + suffix);
    var section = document.getElementById('shopify-section-' + suffix);
    if (!form || !section || !form.matches('form[action*="/cart/add"]')) return;
    section.querySelectorAll('input[name], select[name], textarea[name], button[name="add"]').forEach(function (control) {
      var name = control.getAttribute('name') || '';
      if (!control.form && /^(id|quantity|selling_plan|product-id|section-id|add|properties\[.*\])$/.test(name)) {
        control.setAttribute('form', form.getAttribute('id'));
      }
    });
  }

  function associateProductForms() {
    document.querySelectorAll('button[name="add"][id^="AddToCart--"]').forEach(associateProductControls);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', associateProductForms);
  else associateProductForms();
  document.addEventListener('click', function (event) {
    associateProductControls(event.target.closest('button[name="add"][id^="AddToCart--"]'));
  }, true);

  document.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('[data-vivarro-quantity]');
    var removeButton = event.target.closest('[data-vivarro-remove]');
    if (quantityButton || removeButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var control = quantityButton || removeButton;
      if (control.getAttribute('aria-busy') === 'true') return;
      var cartForm = control.closest('form.vivarro-cart');
      if (cartForm && cartForm.classList.contains('vivarro-cart--updating')) return;
      setCartMutationLoading(control, true);
      runCartMutation(function () {
        return changeLine(
          quantityButton ? quantityButton.dataset.vivarroQuantity : removeButton.dataset.vivarroRemove,
          quantityButton ? Number(quantityButton.dataset.qty) : 0
        ).then(syncDrawer);
      }).catch(cartError).finally(function () { setCartMutationLoading(control, false); });
      return;
    }

    var upsellButton = event.target.closest('[data-vivarro-upsell]');
    if (upsellButton) {
      event.preventDefault();
      var upsellForm = upsellButton.closest('form.vivarro-cart');
      if (upsellForm && upsellForm.classList.contains('vivarro-cart--updating')) return;
      if (upsellButton.getAttribute('aria-busy') === 'true') return;
      setCartMutationLoading(upsellButton, true);
      runCartMutation(function () {
        return addVariant(upsellButton.dataset.vivarroUpsell).then(reloadNativeCart);
      }).catch(cartError)
        .finally(function () {
          setCartMutationLoading(upsellButton, false);
        });
      return;
    }

    var protectionToggle = event.target.closest('[data-vivarro-protection-toggle]');
    if (!protectionToggle) return;

    event.preventDefault();
    var protectionForm = protectionToggle.closest('form.vivarro-cart');
    if (protectionForm && protectionForm.classList.contains('vivarro-cart--updating')) return;
    if (protectionToggle.getAttribute('aria-busy') === 'true') return;
    setCartMutationLoading(protectionToggle, true);

    var config = getConfig();
    runCartMutation(function () { return fetchCart()
      .then(function (cart) {
        var line = (cart.items || []).find(function (item) {
          return String(item.variant_id) === String(config.protection.variantId);
        });

        if (line) return changeLine(line.key, 0);
        return addVariant(config.protection.variantId, { _vivarro_protection: 'true' });
      })
      .then(function (result) { return syncDrawer(result && result.items ? result : null); });
    }).catch(cartError)
      .finally(function () {
        setCartMutationLoading(protectionToggle, false);
      });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form.vivarro-cart') || (!pendingMutations && !syncing)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.vivarroCheckoutPending === 'true') return;
    form.dataset.vivarroCheckoutPending = 'true';
    var button = form.querySelector('[name="checkout"]');
    if (button) { button.classList.add('btn--loading'); button.setAttribute('aria-busy', 'true'); }
    Promise.all([mutationQueue, syncPromise || Promise.resolve()]).then(function () {
      if (mutationFailure) { form.dataset.vivarroCheckoutPending = ''; resetCheckoutLoading(); cartError(mutationFailure); return; }
      // Render may have replaced this form after a quantity update. Submit the current one.
      var current = document.querySelector('form.vivarro-cart');
      if (!current) { resetCheckoutLoading(); return; }
      var checkout = document.createElement('input');
      checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'checkout'; checkout.dataset.vivarroCheckoutInput='true';
      current.appendChild(checkout);
      HTMLFormElement.prototype.submit.call(current);
    }).catch(function(error){ form.dataset.vivarroCheckoutPending=''; resetCheckoutLoading(); cartError(error); });
  }, true);

  // The existing GapBlock bundle owns variant selection and adding its grouped items.
  // Reuse this drawer only after the native cart confirms that addition.
  window.AutrixGapCartAdded = function () {
    var container = document.getElementById('CartContainer');
    if (container) container.dataset.vivarroSignature = '';
    return reloadNativeCart().then(openVivarroDrawer);
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]') || form.querySelector('[data-autrix-bundle]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.dataset.vivarroSubmitting === 'true') return;
    form.dataset.vivarroSubmitting = 'true';

    var submitButton = event.submitter || form.querySelector('[type="submit"][name="add"], [type="submit"]');
    var wasDisabled = submitButton ? submitButton.disabled : false;
    var originalButtonHtml = submitButton ? submitButton.innerHTML : '';
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.classList.add('btn--loading');
    }

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    runCartMutation(function () { return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (response.ok) return response.json();
        return response.json().catch(function () { return {}; }).then(function (error) {
          throw new Error(error.description || 'Impossibile aggiungere il prodotto al carrello.');
        });
      })
      .then(function () {
        var container = document.getElementById('CartContainer');
        if (container) container.dataset.vivarroSignature = '';
        return reloadNativeCart();
      })
      .then(openVivarroDrawer);
    }).catch(function (error) {
        window.alert(error.message || 'Impossibile aggiungere il prodotto al carrello.');
      })
      .finally(function () {
        form.dataset.vivarroSubmitting = '';
        if (submitButton) {
          submitButton.disabled = wasDisabled;
          submitButton.innerHTML = originalButtonHtml;
          submitButton.removeAttribute('aria-busy');
          submitButton.classList.remove('btn--loading');
        }
      });
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('.js-drawer-open-button-right, [href="/cart"], [data-vivarro-cart-trigger]')) scheduleSync();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var dialogWasOpen=false;
    function syncDialogAccess() {
      var open=document.documentElement.classList.contains('js-drawer-open-right');
      drawer.inert=!open;
      drawer.setAttribute('aria-hidden',open ? 'false' : 'true');
      if (open && !dialogWasOpen) {
        if(reservePaint)reservePaint();
        window.requestAnimationFrame(function(){ var close=drawer.querySelector('.js-drawer-close'); if (close && document.documentElement.classList.contains('js-drawer-open-right')) close.focus({preventScroll:true}); });
      }
      dialogWasOpen=open;
    }
    new MutationObserver(syncDialogAccess).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
    syncDialogAccess();
    drawerObserver = new MutationObserver(function () { if (!syncing) scheduleSync(); });
    drawerObserver.observe(drawer, { childList: true, subtree: true });
    scheduleSync();
  });

  function resetCheckoutLoading() {
    if(reservePaint)reservePaint();
    document.querySelectorAll('#CartDrawer .vivarro-checkout, .btn--add-to-cart, .atc_sticky-btn-atc, .atc_collection_anim').forEach(function (button) {
      button.classList.remove('btn--loading');
      button.removeAttribute('aria-busy');
      if(button.matches('#CartDrawer .vivarro-checkout')) button.disabled=false;
    });
  }
  function restoreCartPage(event) {
    resetCheckoutLoading();
    if(!event.persisted) return;
    // Back/forward cache restores transient loading flags as well as the DOM.
    // Read the server cart anew; never replay a previous add-to-cart request.
    cartRevision++;
    syncing=false; syncPromise=null;
    mutationQueue=Promise.resolve(); pendingMutations=0; mutationFailure=null;
    document.querySelectorAll('form[data-vivarro-submitting],form[data-vivarro-checkout-pending]').forEach(function(form){
      form.dataset.vivarroSubmitting=''; form.dataset.vivarroCheckoutPending='';
    });
    document.querySelectorAll('#CartDrawer .vivarro-cart--updating').forEach(function(form){form.classList.remove('vivarro-cart--updating');form.removeAttribute('aria-busy');});
    document.querySelectorAll('#CartDrawer [aria-busy="true"]').forEach(function(control){control.removeAttribute('aria-busy');});
    document.querySelectorAll('[data-vivarro-checkout-input]').forEach(function(input){input.remove();});
    var container=document.getElementById('CartContainer');
    if(container)container.dataset.vivarroSignature='';
    scheduleSync();
  }

  document.addEventListener('keydown', function(event) {
    var drawer=document.getElementById('CartDrawer');
    if (event.key !== 'Tab' || !drawer || !document.documentElement.classList.contains('js-drawer-open-right')) return;
    var controls=Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')).filter(function(node){return node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';});
    if (!controls.length) return;
    var first=controls[0],last=controls[controls.length-1];
    if (event.shiftKey && (document.activeElement===first || !drawer.contains(document.activeElement))) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && (document.activeElement===last || !drawer.contains(document.activeElement))) {event.preventDefault();first.focus();}
  });
  document.addEventListener('autrix:cart-closed',function(){if(pendingMutations===0)resetCheckoutLoading();});
  window.addEventListener('pageshow', restoreCartPage);
  window.addEventListener('focus', resetCheckoutLoading);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) resetCheckoutLoading();
  });
})();


/* Vivarro cart drawer: cierre delegado para contenido re-renderizado */
(function () {
  'use strict';

  function closeVivarroCart() {
    document.dispatchEvent(new Event('autrix:cart-closed'));
    var openClasses = ['js-drawer-open', 'js-drawer-open-left', 'js-drawer-open-right'];

    [document.documentElement, document.body].forEach(function (node) {
      if (!node) return;
      openClasses.forEach(function (className) {
        node.classList.remove(className);
      });
    });

    if (window.jQuery) {
      window.jQuery('.page-container').off('touchmove.drawer');
      window.jQuery(document).off('focusin.drawer');
    }

    var cartTrigger = document.querySelector('a[href$="/cart"]');
    if (cartTrigger && typeof cartTrigger.focus === 'function') {
      try {
        cartTrigger.focus({ preventScroll: true });
      } catch (error) {
        cartTrigger.focus();
      }
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var closeButton = event.target.closest('#CartDrawer .js-drawer-close');
    var overlay = event.target.closest('.blur_open_drawer');

    if (!closeButton && !overlay) return;

    event.preventDefault();
    event.stopPropagation();
    closeVivarroCart();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeVivarroCart();
  });
})();


/* Vivarro cart drawer: el icono abre el drawer sin navegar a /cart */
(function () {
  'use strict';

  function openVivarroCart() {
    [document.documentElement, document.body].forEach(function (node) {
      if (!node) return;
      node.classList.remove('js-drawer-open-left');
      node.classList.add('js-drawer-open', 'js-drawer-open-right');
    });

    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.setAttribute('tabindex', '-1');
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var cartLink = event.target.closest('a[href$="/cart"]');
    if (!cartLink || cartLink.closest('#CartDrawer')) return;
    if (document.body.classList.contains('template-cart')) return;

    event.preventDefault();
    event.stopPropagation();
    openVivarroCart();
  }, true);
})();


/* Vivarro cart drawer: activador estable para aperturas repetidas */
(function () {
  'use strict';

  function prepareCartTriggers() {
    if (document.body.classList.contains('template-cart')) return;

    document.querySelectorAll('a[href$="/cart"], a[data-vivarro-cart-trigger]').forEach(function (link) {
      if (link.closest('#CartDrawer')) return;
      link.setAttribute('data-vivarro-cart-trigger', '');
      link.setAttribute('href', '#CartDrawer');
      link.setAttribute('aria-controls', 'CartDrawer');
      link.setAttribute('aria-haspopup', 'dialog');
    });
  }

  function openPreparedCart() {
    [document.documentElement, document.body].forEach(function (node) {
      if (!node) return;
      node.classList.remove('js-drawer-open-left');
      node.classList.add('js-drawer-open', 'js-drawer-open-right');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareCartTriggers);
  } else {
    prepareCartTriggers();
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var trigger = event.target.closest('[data-vivarro-cart-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openPreparedCart();
  }, true);
})();
